
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M43.654 3.05c-.75-.636-1.928-.727-3.146-.238h-.002C39.225 3.326 4.245 18.33 2.82 18.942c-.26.09-2.521.935-2.288 2.815.208 1.695 2.026 2.397 2.248 2.478l8.893 3.045c.59 1.964 2.765 9.21 3.246 10.758.3.965.789 2.233 1.646 2.494.752.29 1.5.025 1.984-.355l5.437-5.043 8.777 6.845.209.125c.596.264 1.167.396 1.712.396.42 0 .825-.08 1.21-.237 1.316-.54 1.842-1.793 1.897-1.935L44.348 6.25c.4-1.82-.156-2.746-.694-3.201zM19.517 28.498l-3 8-3-10 23-17-17 19z","fill":"#000","fill-rule":"nonzero"}})])
          )
        }
      }
    